export const RASPADINHA_EXAMPLE_CAMPAIGN_LABEL = '(exemplo de campanha raspadinha)'

export function withRaspadinhaExampleCampaignLabel(text: string): string {
  const trimmed = text.trim()
  if (!trimmed) {
    return RASPADINHA_EXAMPLE_CAMPAIGN_LABEL
  }
  if (trimmed.endsWith(RASPADINHA_EXAMPLE_CAMPAIGN_LABEL)) {
    return trimmed
  }
  return `${trimmed} ${RASPADINHA_EXAMPLE_CAMPAIGN_LABEL}`
}
